import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { translationsRootKey, tableConfig } from '../../../settings/index';
import Api from '../../../helpers/api';
import { sendRequest } from '../../../helpers/saga';
import { logger } from '../../../helpers/logger';
import notifications from '../../../redux/notifications/actions';
import appActions from '../../../redux/app/actions';
import { t } from '../../../i18n';

const api = new Api('jobs/past');

function* loadData({ payload }) {
  try {
    const {
      page = 1,
      pageSize = tableConfig.pageSize,
      column = 'starts_at',
      order = 'descend',
      filter = '',
      job_group_id,
      company_id,
      worker_id,
      expand,
      currentPage,
    } = payload;
    const isLoadMoreClicked = job_group_id && expand;

    let { district = [] } = payload;

    if (!Array.isArray(district)) {
      district = [district];
    }

    const result = yield call(
      sendRequest,
      api.load,
      {
        search: {
          ...payload,
          page: isLoadMoreClicked ? 1 : page, // When load more has been clicked set page to 1 but increase pageSize
          pageSize,
          column: column === 'date' ? 'starts_at' : column,
          order,
          filter,
          job_group_id,
          company_id,
          worker_id,
          district,
        },
      },
      notifications.REQUEST_ERROR,
    );

    if (result.data && result.data.success && result.data.success.data) {
      const { records, totalCount, filteredCount, sortable_columns, job_group, filters, saved_searches } =
        result.data.success.data;

      if (job_group && expand) {
        yield put(
          actions.loadMultiDayDataSuccess({
            data: records,
            total: totalCount,
            pageSize,
            currentPage,
            filteredTotal: filteredCount,
            sortableColumns: sortable_columns,
            jobGroup: job_group,
            savedSearches: saved_searches,
          }),
        );
      } else {
        yield put(
          actions.loadDataSuccess({
            data: records,
            total: totalCount,
            filteredTotal: filteredCount,
            pageSize,
            sortableColumns: sortable_columns,
            jobGroup: job_group,
            isTalentPage: !!worker_id,
            filters,
            savedSearches: saved_searches,
          }),
        );
      }

      yield put(appActions.changeBreadcrumbState({ prop: 'jobs/:id', value: '' }));

      if (company_id || worker_id) {
        yield put(
          appActions.changeBreadcrumbState({
            prop: 'jobs',
            value: {
              label: company_id
                ? t('dash.jobs.client_past_jobs_label')
                : t(`${translationsRootKey}.jobs.talent_past_jobs_label`),
              path: `/jobs?tab=past&${worker_id ? `worker_id=${worker_id}` : `company_id=${company_id}`}`,
            },
          }),
        );
      }

      if (job_group_id) {
        yield put(
          appActions.changeBreadcrumbState({
            prop: 'jobs/multiDay',
            value: {
              label: t('dash.jobs.multi_day_job_label'),
              path: `/jobs/multiDay?tab=pasts&job_group_id=${job_group_id}`,
            },
          }),
        );
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

export { loadData };
export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData)]);
}
